import classNames from 'classnames'
import { JSX, MutableRefObject, useCallback, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import { selectAppOwnerId } from 'core-components/sitebuilder/store/selectors/selectAppOwnerId'

import styles from './Banner.module.scss'

const SHOW_DELAY = 10000

export const Banner = () => {
  const ownerId = useSelector(selectAppOwnerId)
  const isProduction = ownerId.includes('-prod')
  const [bannerState, setBannerState] = useState<'hide' | 'show'>('show')
  const hideTimerRef = useRef<number | null>(null)
  const showTimerRef = useRef<number | null>(null)

  const clearTimer = (timer: MutableRefObject<number | null | undefined>) => {
    if (timer.current) {
      clearTimeout(timer.current)
      timer.current = null
    }
  }
  const mouseEnterHandler = useCallback(() => {
    clearTimer(showTimerRef)
    if (!hideTimerRef.current) {
      setBannerState('hide')
    }
  }, [])

  if (isProduction) {
    return null
  }

  return (
    <div
      className={classNames(styles.notification, styles[`notification-${bannerState}`])}
      onMouseEnter={mouseEnterHandler}
      onMouseMove={mouseEnterHandler}
      onMouseLeave={() => {
        clearTimer(hideTimerRef)
        clearTimer(showTimerRef)
        showTimerRef.current = window.setTimeout(() => {
          setBannerState('show')
        }, SHOW_DELAY)
      }}
    >
      <span>This is a test environment</span>
    </div>
  )
}
